/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondToAppraisalRequestOneOf1
 */
export interface RespondToAppraisalRequestOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof RespondToAppraisalRequestOneOf1
     */
    outcome: RespondToAppraisalRequestOneOf1OutcomeEnum;
    /**
     * 
     * @type {number}
     * @memberof RespondToAppraisalRequestOneOf1
     */
    requestEventId: number;
    /**
     * Required and must contain non-whitespace explanation for non-accepted outcomes.
     * @type {string}
     * @memberof RespondToAppraisalRequestOneOf1
     */
    notes: string;
}


/**
 * @export
 */
export const RespondToAppraisalRequestOneOf1OutcomeEnum = {
    NotReady: 'not_ready',
    Litigation: 'litigation',
    Settlement: 'settlement'
} as const;
export type RespondToAppraisalRequestOneOf1OutcomeEnum = typeof RespondToAppraisalRequestOneOf1OutcomeEnum[keyof typeof RespondToAppraisalRequestOneOf1OutcomeEnum];


/**
 * Check if a given object implements the RespondToAppraisalRequestOneOf1 interface.
 */
export function instanceOfRespondToAppraisalRequestOneOf1(value: object): value is RespondToAppraisalRequestOneOf1 {
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    if (!('requestEventId' in value) || value['requestEventId'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function RespondToAppraisalRequestOneOf1FromJSON(json: any): RespondToAppraisalRequestOneOf1 {
    return RespondToAppraisalRequestOneOf1FromJSONTyped(json, false);
}

export function RespondToAppraisalRequestOneOf1FromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToAppraisalRequestOneOf1 {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'],
        'requestEventId': json['requestEventId'],
        'notes': json['notes'],
    };
}

export function RespondToAppraisalRequestOneOf1ToJSON(json: any): RespondToAppraisalRequestOneOf1 {
    return RespondToAppraisalRequestOneOf1ToJSONTyped(json, false);
}

export function RespondToAppraisalRequestOneOf1ToJSONTyped(value?: RespondToAppraisalRequestOneOf1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': value['outcome'],
        'requestEventId': value['requestEventId'],
        'notes': value['notes'],
    };
}

